import { Button, Checkbox, FormControlLabel, LoadingButton, MultiLineTextField, SwitchLabel, TextField } from '@frontend-workspace/react-shared-lib';
import { List, ListItem } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GetCurrentCompany } from '../customer-context/customer-context';
import styles from './main-helper.module.css';
import { useTranslation } from 'react-i18next';
import { useMakeRequestHook } from '../requestUtils';

export interface GPTMessage {
  content: string;
  hideInChat?: boolean;
  role: string
}
/* eslint-disable-next-line */
export interface MainHelperProps {
  isFullPage?: boolean;
  messages: GPTMessage[];
  setMessages: (messages: GPTMessage[]) => void;
  setCompany: any;
}

export function GPTHelper(props: MainHelperProps) {
  const currentCompany = GetCurrentCompany();
  const makeRequest = useMakeRequestHook();
  const chatEndRef = useRef<any>(null);
  const [message, setMessage] = useState<string>("");
  const [voiceResponse, setVoiceResponse] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isEnglish, setIsEnglish] = useState<boolean>(false);
  const [isNavigation, setIsNavigation] = useState<boolean>(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const mediaRecorderRef = useRef<any>(null);
  const audioChunksRef = useRef<any[]>([]);
  const toggleNavigation = () => {
    setIsNavigation(!isNavigation);
  }
  const handleResponse = (response: any) => {
    setIsLoading(false);
    setMessage("");
    props.setMessages(response.messages);

    const lastMessage = response.messages[response.messages.length - 1];

    if (response.audio) {
      const audio = new Audio(`data:audio/mp3;base64,${response.audio}`);
      audio.play();
    }
    if (lastMessage.navigationUrl) {
      navigate(lastMessage.navigationUrl);
      props.setCompany(lastMessage.companyNumber);
    }
    if (lastMessage.content.includes(t("standard.sendingYouTo"))) {
      const content: string = lastMessage.content;
      const lastMessageNavigationUrl = content.slice(content.indexOf("/"));

      const match = content.match(/\d+/); // Matches any sequence of digits in the string
      const number = match ? parseInt(match[0], 10) : null;
      navigate(lastMessageNavigationUrl);
      props.setCompany(number);
    }

  }

  useEffect(() => {
    // navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
    //   mediaRecorderRef.current = new MediaRecorder(stream, { mimeType: 'audio/webm' });
    //   mediaRecorderRef.current.ondataavailable = (event: { data: any; }) => {
    //     audioChunksRef.current.push(event.data);
    //   };

    //   mediaRecorderRef.current.onstop = () => {
    //     handleVoiceRequest(props.messages);
    //     audioChunksRef.current = [];
    //   };
    // });

    // const handleVoiceRequest = (messages: GPTMessage[]) => {
    //   const audioBlob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
    //   const formData = new FormData();
    //   formData.append('audio', audioBlob, 'audio.webm');
    //   formData.append('language', isEnglish ? "en" : "no");
    //   formData.append("messages", JSON.stringify(messages));
    //   formData.append("voiceResponse", voiceResponse.toString());
    //   formData.append("currentUrl", window.location.href);
    //   formData.append("companyNumber", currentCompany?.number || "");
    //   setIsLoading(true);
    //   makeVoiceRequest("gpt/helper/voice", formData).then(handleResponse);

    //   audioChunksRef.current = [];
    // };


    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);

    const scrollableElement = chatEndRef.current;
    if (chatEndRef.current) {
      if (scrollableElement) {
        scrollableElement.scrollTop = scrollableElement.scrollHeight;
      }
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [props.messages, message]);
  const handleKeyDown = (e: any) => {
    // if (e.ctrlKey && e.altKey) {
    //   onStartRecorder();
    // }
    if (e.key === 'Enter' && message.length > 3) {
      handleSendMessage();
    }
  };

  const handleKeyUp = (e: any) => {
    // if (e.key === 'Control') {
    //   onStopRecorder();
    // }
  };
  // const onStartRecorder = () => {
  //   if (mediaRecorderRef.current.state !== 'recording') {
  //     mediaRecorderRef.current.start();
  //   }
  // };
  // const onStopRecorder = () => {
  //   if (mediaRecorderRef.current && mediaRecorderRef.current.state === 'recording') {
  //     mediaRecorderRef.current.stop(); // Stopping the media recorder
  //   }
  // }
  const handleSendMessage = () => {
    const createLastMessage = (message: string): GPTMessage => {
      return {
        role: "user",
        content: message,
        hideInChat: false
      }
    }
    if (isNavigation) {
      const sentMessages = [...props.messages, createLastMessage(message)];
      setIsLoading(true);
      makeRequest("GPT/helper/navigation", "POST", {
        messages: sentMessages,
        currentUrl: window.location.href,
        companyNumber: currentCompany?.number
      }).then(handleResponse);
    }
    else {
      const sentMessages = [...props.messages, createLastMessage(message)];
      setIsLoading(true);
      makeRequest("GPT/helper/page", "POST", {
        isVoiceMessage: voiceResponse,
        messages: sentMessages,
        currentUrl: window.location.href,
        companyNumber: currentCompany?.number
      }).then(handleResponse);

    }
  }
  return (
    <>
      {/* <div>
        <FormControlLabel
          control={
            <Checkbox
              checked={voiceResponse}
              onChange={(e: any) => setVoiceResponse(e.target.checked)}
            />
          }
          label="Svar med stemme"
        />
      </div> */}
      <SwitchLabel
        label={t("gptHelper.findRightPage")}
        checked={isNavigation}
        onChange={toggleNavigation}
      />
      <SwitchLabel
        label={t("gptHelper.pageAssistance")}
        checked={!isNavigation}
        onChange={toggleNavigation}
      />
      <Button onClick={() => props.setMessages([])}>
        {t("gptHelper.clearChat")}
      </Button>
      <List style={{ maxHeight: '70vh', width: "210px", overflow: "auto" }} ref={chatEndRef}>
        {props.messages.filter(m => m.role !== "system" && !m.hideInChat).map(m => {
          const isUser = m.role === 'user';
          const messageStyle = {
            fontSize: '0.8em',
            background: isUser ? '#e0f7fa' : '#eceff1', // light blue for user, light gray for assistant
            margin: isUser ? '10px 10px 10px auto' : '10px auto 10px 10px', // aligns user messages right, assistant messages left
            padding: '10px',
            borderRadius: '20px',
            maxWidth: '80%', // limits bubble width
          };
          return (
            <ListItem style={messageStyle}>
              <div>
                {m.content}
              </div>
            </ListItem>
          );
        })}
        {isLoading && <ListItem>
          {t("standard.working")}...
        </ListItem>}
      </List>
      <MultiLineTextField
        value={message}
        disabled={isLoading}
        placeholder={String(t("gptHelper.writeAMessage"))}
        onChange={(e) => setMessage(e.target.value)}
      />
    </>
  );
}

export default GPTHelper;
